const CheckboxCheckedIcon = ({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <rect width={20} height={20} fill="#61DFFF" rx={2.5} />
      <path
        fill="#231F20"
        stroke="#231F20"
        strokeWidth={0.375}
        d="M5.165 9.078a.656.656 0 0 1 .515.25l-.515-.25Zm0 0H4.14a.304.304 0 0 0-.24.493l4.013 5.083a.658.658 0 0 0 1.03 0l7.154-9.065a.304.304 0 0 0-.238-.492h-1.024c-.2 0-.392.092-.516.25l-5.892 7.464M5.165 9.078l3.263 3.733m0 0L5.68 9.328l2.748 3.483Z"
      />
    </svg>
  )
}

export default CheckboxCheckedIcon
